(() => {

    "use strict";

    const SELECTOR = ".women-store-info";

    function init(section) {

        if (!section || section.dataset.wsiReady === "true") return;

        section.dataset.wsiReady = "true";

        const cards = [...section.querySelectorAll(".women-store-info__card")];

        cards.forEach((card, index) => {

            const button = card.querySelector(".women-store-info__card-toggle");
            const content = card.querySelector(".women-store-info__card-content");

            if (!button || !content) return;

            if (!content.id) {
                content.id = `wsi-content-${index}`;
            }

            button.setAttribute("aria-controls", content.id);

            const open = card.classList.contains("is-open");

            button.setAttribute("aria-expanded", open);

            if (!open) {

                content.style.height = "0px";
                content.style.overflow = "hidden";

            } else {

                content.style.height = content.scrollHeight + "px";

            }

            button.addEventListener("click", () => {

                const isOpen = card.classList.contains("is-open");

                cards.forEach(other => {

                    const otherButton = other.querySelector(".women-store-info__card-toggle");
                    const otherContent = other.querySelector(".women-store-info__card-content");

                    if (!otherButton || !otherContent) return;

                    other.classList.remove("is-open");

                    otherButton.setAttribute("aria-expanded", "false");

                    otherContent.style.height = "0px";

                });

                if (isOpen) return;

                card.classList.add("is-open");

                button.setAttribute("aria-expanded", "true");

                content.style.height = content.scrollHeight + "px";

            });

        });

        

        cards.forEach(card => {

            card.addEventListener("mousemove", e => {

                const rect = card.getBoundingClientRect();

                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;

                card.style.setProperty("--mouse-x", `${x}px`);
                card.style.setProperty("--mouse-y", `${y}px`);

            });

        });

        if ("IntersectionObserver" in window) {

            const observer = new IntersectionObserver(entries => {

                entries.forEach(entry => {

                    if (!entry.isIntersecting) return;

                    entry.target.classList.add("is-visible");

                    observer.unobserve(entry.target);

                });

            }, {

                threshold: .15

            });

            cards.forEach(card => observer.observe(card));

        }

    }

    document.querySelectorAll(SELECTOR).forEach(init);

    document.addEventListener("shopify:section:load", e => {

        const section = e.target.querySelector(SELECTOR) || e.target;

        init(section);

    });

    /* ===========================
   Section Reveal
=========================== */

if ("IntersectionObserver" in window) {

    const sectionObserver = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

            if (!entry.isIntersecting) return;

            entry.target.classList.add("is-visible");

            sectionObserver.unobserve(entry.target);

        });

    }, {

        threshold: 0.15

    });

    document.querySelectorAll(SELECTOR).forEach(section => {
        sectionObserver.observe(section);
    });

} else {

    document.querySelectorAll(SELECTOR).forEach(section => {
        section.classList.add("is-visible");
    });

}

})();